import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TankService } from 'src/app/services/tank.service';
import { UserService } from 'src/app/services/user.service';
import { VehicleService } from 'src/app/services/vehicle.service';
import { VoucherService } from 'src/app/services/voucher.service';
import { User } from 'src/app/shared/models/User';
import { Vehicle } from 'src/app/shared/models/Vehicle';
import { Voucher } from 'src/app/shared/models/Voucher';
import { DatepickerRangeComponent } from '../../partials/datepicker-range/datepicker-range.component';

@Component({
  selector: 'app-voucher-page',
  templateUrl: './voucher-page.component.html',
  styleUrls: ['./voucher-page.component.css']
})
export class VoucherPageComponent implements OnInit {

  @ViewChild(DatepickerRangeComponent) datepickerRangeComponent: DatepickerRangeComponent;

  voucherForm: FormGroup;
  titulo = 'Crear Voucher para: ';
  tankName: string;
  tankId: number;
  id: number;
  km_is_active = true;
  select_disabled = false;
  select_disabled_operators = false;


  operatorList: User[] = [];
  selectedOperators: User[] = [];
  operatorSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false
  };


  vehicleList: Vehicle[] = [];
  selectedVehicles: Vehicle[] = [];
  vehicleSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false
  };



  constructor(private fb: FormBuilder, private router: Router, private activatedRoute: ActivatedRoute, private voucherService: VoucherService,
    private _tankService: TankService, private userService: UserService, private vehicleService: VehicleService) {
    this.voucherForm = this.initVoucherForm();
    this.id = parseInt(this.activatedRoute.snapshot.paramMap.get('id'), 10);
  }

  ngOnInit() {
    this.initializeEditMode();

  }

  selectAllVehicles() {
    // this.selectedVehicles = this.vehicleList.map(vehicle => vehicle._id);
    // const aux = this.vehicleList.map((e) => {return {id: e.id,name: e.name}})
    this.select_disabled = !this.select_disabled;
    this.voucherForm.controls['vehicles'].setValue([{id: 0, name: 'TODOS'}]);
    this.voucherForm.controls['vehicles'].markAsDirty();
    // console.log(this.vehicleList)

  }

  selectAllOperators() {
    this.select_disabled_operators = !this.select_disabled_operators;
    this.voucherForm.controls['operators'].setValue([{id: 0, name: 'TODOS'}]);
    this.voucherForm.controls['operators'].markAsDirty();
  }

  saveVoucher() {
    if (this.voucherForm.invalid) {
      return;
    }
    console.log(this.voucherForm.value)
    // console.log("submit ",this.voucherForm.value)
    const voucher: Voucher = this.voucherForm.value;
    voucher.tankId = this.tankId;

    voucher.initDate = this.datepickerRangeComponent.getSelectedDates().fromDate;
    voucher.expirationDate = this.datepickerRangeComponent.getSelectedDates().toDate;
    //voucher.operator_name = voucher.operator[0].name;
    voucher.operators = voucher.operators.map((e) => e.id);
    // console.log("operador", voucher.operator)
    // console.log("operador_name", voucher.operator_name)
    // if (voucher.vehicles.length !=1  && voucher.vehicles[0].id != 0)
      voucher.vehicles = voucher.vehicles.map( (e) => e.id);
    voucher.available = voucher.amount;

    if (voucher.single_use) {
      voucher.single_use = true; // Asegurar que solo se puede usar una vez
    }

    const now = new Date();

    if (voucher.expirationDate <= now) {
      voucher.status = "EXPIRED";
    } else if (voucher.initDate <= now) {
      voucher.status = "ACTIVE";
    } else {
      voucher.status = "PENDING";
    }
    if (voucher.operators[0] == 0){
      voucher.operator = this.operatorList[0].id;
    }else {
      voucher.operator = voucher.operators[0];
    }
    console.log(voucher)
    const saveOrUpdate = this.id
      ? this.voucherService.editVoucher(this.id, voucher)
      : this.voucherService.saveVoucher(voucher);

    saveOrUpdate.subscribe(
      () => this.router.navigate(['/vouchers']),
      (error) => {
        console.log(error);
        this.voucherForm.reset();
      }
    );
  }

  private initVoucherForm(): FormGroup {

    this._tankService.getCurrentTank().subscribe((tank) => {
      this.tankName = tank.name;
      this.tankId = tank.id;
      this.UpdateLists();
    });


    return this.fb.group({
      tankId: [''],
      description: ['', Validators.required],
      initDate: [''],
      expirationDate: [''],
      amount: ['', Validators.required],
      available: [''],
      status: [''],
      operators: ['', Validators.required],
      vehicles: ['', Validators.required],
      km_is_active: [true, Validators.required],
      single_use: [false, Validators.required]
    });
  }

  private initializeEditMode() {
    if (this.id) {
      this.titulo = 'Editar Voucher para: ';
      this.voucherService.getVoucher(this.id).subscribe((data) => {
        this.voucherForm.patchValue(data);
        // console.log('vehiculo_id: ', data.vehicle)
        //this.selectedVehicle = data.vehicle;
        //this.selectedOperator = data.operator;

      });

    }
  }

  private UpdateLists() {

    this.userService.getOperatorsByTank(this.tankId).subscribe((operatorList: User[]) => {
      this.operatorList = operatorList;
      this.selectedOperators = [];
    });

    this.vehicleService.getVehicleByTank(this.tankId).subscribe((vehicleList: Vehicle[]) => {
      // console.log(vehicleList,"s")
      this.vehicleList = vehicleList;
      // this.selectedVehicles = new Vehicle;
    });
  }

}
